// German translations for Plan Summary feature
// Location: src/i18n/locales/de/planSummary.ts

export default {
    // Page Header
    header: {
        title: 'Plan-Zusammenfassung',
        dateRange: '{{startDate}} - {{endDate}}',
        actions: {
            downloadPdf: 'PDF',
            share: 'Teilen',
            saveJourney: "Reise speichern"
        },
    },

    "sections": {
        journey: "Der Weg",
        weeklyPerformance: "Wöchentliche Leistung",
        dailyHighlights: "Tägliche Höhepunkte",
        aiAnalysis: "KI-Analyse",
        trophyRoom: "Trophäenraum"
    },

    // Quick Stats (Header Cards)
    quickStats: {
        weightChange: 'Gewichtsänderung',
        completion: 'Abschluss',
        adherence: 'Einhaltung',
        goalStatus: 'Zielstatus',
        achieved: 'Erreicht',
        inProgress: 'In Bearbeitung',
    },

    // Summary Stats
    stats: {
        startWeight: 'Startgewicht',
        endWeight: 'Endgewicht',
        daysCompleted: 'Tage abgeschlossen',
        mealsLogged: 'Mahlzeiten protokolliert',
        avgCalories: 'Ø Kalorien/Tag',
        avgProtein: 'Ø Protein/Tag',
        avgCarbs: 'Ø Kohlenhydrate/Tag',
        avgFat: 'Ø Fett/Tag',
    },

    // Weight Journey Chart
    weightJourney: {
        title: 'Gewichtsverlauf',
        subtitle: "Verfolge deinen Fortschritt im Laufe der Zeit",
        legend: {
            progress: 'Dein Fortschritt',
            goal: 'Ziel',
        },
        tooltip: {
            weight: 'Gewicht',
        },
        summary: {
            start: 'Start',
            end: 'Ende',
            change: 'Änderung',
        },
        loading: 'Diagramm wird geladen...',
    },

    // Weekly Breakdown
    weeklyBreakdown: {
        title: 'Wöchentliche Übersicht',
        subtitle: "Wöchentliche Beständigkeit",
        bestWeek: 'Beste: Woche {{week}} ({{adherence}}%)',
        week: 'Woche {{number}}',
        daysCompleted: '{{count}} Tage abgeschlossen',
        adherence: 'Einhaltung',
        performance: {
            excellent: 'Ausgezeichnete Beständigkeit!',
            good: 'Guter Fortschritt',
            improvement: 'Verbesserungspotenzial',
        },
        summary: {
            avgAdherence: 'Ø Einhaltung',
            totalWeightChange: 'Gesamte Gewichtsänderung',
            weeksCompleted: 'Wochen abgeschlossen',
        },
    },

    // Best/Worst Days
    performanceHighlights: {
        title: 'Leistungs-Highlights',
        subtitle: "Tägliche Höhen und Tiefen",
        bestDays: {
            title: 'Beste Tage',
            day: 'Tag {{number}}',
            empty: 'Keine perfekten Tage aufgezeichnet',
        },
        worstDays: {
            title: 'Herausfordernde Tage',
            day: 'Tag {{number}}',
            empty: 'Keine herausfordernden Tage - großartige Arbeit!',
        },
        insights: {
            moreBest: 'Du hattest mehr perfekte als herausfordernde Tage! Das zeigt starke Beständigkeit und Hingabe zu deinem Plan.',
            moreWorst: 'Nutze herausfordernde Tage als Lernmöglichkeiten. Erkenne Muster und bereite Strategien für ähnliche Situationen vor.',
            consistent: 'Deine Leistung war während des gesamten Plans bemerkenswert konstant. Behalte diese ausgezeichnete Disziplin bei!',
        },
    },

    // Insights Card
    insights: {
        title: 'KI-Einblicke',
        subtitle: "Intelligente Beobachtungen basierend auf deinen Daten",
        empty: 'Keine spezifischen Einblicke für diesen Plan generiert',
        generalTips: {
            title: 'Allgemeine Tipps',
            consistency: 'Beständigkeit ist wichtiger als Perfektion',
            timing: 'Wiege dich täglich zur gleichen Zeit',
            improvements: 'Kleine tägliche Verbesserungen führen zu großen Ergebnissen',
        },
    },

    // Achievements
    achievements: {
        title: 'Errungenschaften freigeschaltet',
        subtitle: "In diesem Plan erreichte Meilensteine",
        unlockedLabel: "Freigeschaltet",
        badge: 'Abzeichen',
        badges: 'Abzeichen',
        celebration: {
            title: 'Erstaunlicher Fortschritt! 🎉',
            message: 'Du hast {{count}} Errungenschaft während dieses Plans freigeschaltet. Jede repräsentiert deine Hingabe und harte Arbeit!',
            messagePlural: 'Du hast {{count}} Errungenschaften während dieses Plans freigeschaltet. Jede repräsentiert deine Hingabe und harte Arbeit!',
        },
    },

    // Next Steps
    nextSteps: {
        title: 'Was kommt als Nächstes?',
        message: {
            goalAchieved: {
                title: 'Glückwunsch zum Erreichen deines Ziels!',
                description: 'Du hast dein Ziel erreicht! Jetzt ist es Zeit, entweder deine Ergebnisse zu halten oder eine neue Herausforderung zu setzen. Die Wahl liegt bei dir!',
            },
            goodAdherence: {
                title: 'Weiter so!',
                description: 'Du hast großartige Beständigkeit gezeigt ({{adherence}}% Einhaltung). Mit ein paar Anpassungen erreichst du dein Ziel im nächsten Plan!',
            },
            needsImprovement: {
                title: 'Weiter so!',
                description: 'Du hast den Plan mit {{adherence}}% Einhaltung abgeschlossen. Lass uns zusammenarbeiten, um den nächsten noch besser zu machen!',
            },
        },
        actions: {
            newPlan: {
                title: 'Neuen Plan starten',
                descriptionAchieved: 'Setze ein neues Ziel und halte den Schwung aufrecht!',
                descriptionContinue: 'Setze deine Reise mit einem frischen 30-Tage-Plan fort',
            },
            maintenance: {
                title: 'Erhaltungsmodus',
                descriptionAchieved: 'Behalte deine Ergebnisse mit einem Erhaltungsplan',
                descriptionContinue: 'Halte dein aktuelles Gewicht, während du Gewohnheiten aufbaust',
            },
            adjust: {
                title: 'Ansatz anpassen',
                descriptionLow: 'Lass uns deinen Plan basierend auf dem Besten, was funktioniert hat, verfeinern',
                descriptionHigh: 'Baue auf deinem Erfolg mit optimierten Strategien auf',
            },
            getStarted: 'Loslegen',
        },
        quickActions: {
            title: 'Schnellaktionen',
            dashboard: 'Zurück zum Dashboard',
            progress: 'Gesamten Fortschritt anzeigen',
            askBot: 'NutriBot fragen',
        },
    },

    // Loading States
    loading: {
        title: 'Zusammenfassung wird geladen...',
        generating: 'Deine Zusammenfassung wird erstellt...',
        description: 'Bitte warten...',
        generatingDescription: 'Dies dauert etwa 30 Sekunden',
    },

    // Error States
    error: {
        title: 'Zusammenfassung konnte nicht geladen werden',
        tryAgain: 'Erneut versuchen',
        backToDashboard: 'Zurück zum Dashboard',
    },

    // Plan Completion Modal
    completionModal: {
        title: 'Plan abgeschlossen!',
        subtitle: 'Du hast deine {{days}}-Tage-Reise beendet!',
        stats: {
            daysCompleted: 'Tage abgeschlossen',
            weightChange: 'Gewichtsänderung',
        },
        goalAchieved: {
            title: 'Ziel erreicht! 🎯',
            description: 'Du hast dein Zielgewicht erreicht!',
        },
        actions: {
            viewSummary: 'Plan-Zusammenfassung anzeigen',
            generateSummary: 'Meine Zusammenfassung erstellen',
            checkStatus: 'Status prüfen',
            later: 'Ich schaue später',
        },
        status: {
            checking: 'Wird geprüft...',
            generating: 'Zusammenfassung wird erstellt...',
        },
    },

    // Plan Summary Banner
    banner: {
        lastDay: {
            complete: '🏆 Letzter Tag abgeschlossen!',
            completeDescription: 'Deine Plan-Zusammenfassung wird erstellt...',
            incomplete: '🎯 Du bist bei Tag {{current}}/{{total}}!',
            incompleteDescription: 'Vervollständige deine letzten Mahlzeiten, um deinen Plan abzuschließen',
        },
        planComplete: {
            title: '🎉 Plan abgeschlossen!',
            description: 'Deine Plan-Zusammenfassung ist bereit zur Ansicht',
        },
        actions: {
            viewSummary: 'Zusammenfassung anzeigen',
            checkStatus: 'Status prüfen',
        },
    },

    // Metadata
    metadata: {
        generatedOn: 'Erstellt am {{date}} um {{time}}',
        generatedBy: 'Erstellt von: {{source}}',
        sources: {
            user: 'Benutzeranfrage',
            cron: 'Automatisches System',
        },
    },

    // Alerts
    alerts: {
        linkCopied: 'Link in Zwischenablage kopiert!',
        pdfComingSoon: 'PDF-Download kommt bald!',
        summaryGenerationFailed: 'Zusammenfassung konnte nicht erstellt werden. Bitte versuche es erneut.',

        generatingPDF: 'PDF wird erstellt...',
        pdfDownloaded: 'PDF erfolgreich heruntergeladen!',
        pdfGenerationFailed: 'PDF konnte nicht erstellt werden. Bitte versuche es erneut.',
    },

    prompts: {
        newPlan: "Ich möchte einen neuen Plan mit Fokus auf Erhaltung.",
        maintenance: "Ich möchte einen neuen Plan mit Fokus auf Erhaltung.",
        adjustPlan: "Ich möchte meinen aktuellen Plan anpassen.",
        askAboutSummary: "Was hältst du von meiner Planübersicht?"
    },
};